var _defs, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModelingExtrudeSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "xaml",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#aeaeb6;}.cls-2{fill:#d0d0d7;}.cls-3{fill:#363545;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ModelingExtrude_svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26,26c-.38-.68-3.66-1.85-9-2v2h0a1,1,0,0,1-2,0h0V24c-5.06.13-8.26,1.19-8.9,1.88V26H6s0,0,0,0c.27.59,3.52,1.8,8.9,1.94L16,28l1.1,0,.67,0,.36,0C22.79,27.69,25.63,26.63,26,26Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15,8V6h0a1,1,0,0,1,2,0s0,0,0,0V8c5.34-.14,8.62-1.31,9-2-.41-.72-4.06-2-10-2S6.31,5.32,6,6v0C6.29,6.65,9.57,7.85,15,8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.8,22.3l.55.08A16.81,16.81,0,0,1,26,23.62V8.38c-2.28,1.1-6.07,1.53-9,1.6V22c1.23,0,2.4.12,3.48.25Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.53,22.26C12.61,22.13,13.77,22,15,22V10c-2.93-.07-6.7-.5-9-1.6l.08,15.2a17.11,17.11,0,0,1,4.55-1.2l.75-.1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M16,2C11.54,2,4,2.84,4,6H4l.1,19.41A1.92,1.92,0,0,0,4,26c0,3.16,7.54,4,12,4s12-.84,12-4V6C28,2.84,20.46,2,16,2ZM26,23.62a16.81,16.81,0,0,0-4.65-1.24l-.55-.08-.32,0c-1.2-.14-2.4-.22-3.48-.24h0V10c2.94-.07,6.73-.5,9-1.6Zm-19.91,0L6,8.38c2.28,1.1,6.05,1.53,9,1.6V22h0c-1.08,0-2.28.1-3.47.24l-.14,0-.75.1A17.11,17.11,0,0,0,6.09,23.58ZM16,4c5.93,0,9.58,1.28,10,2-.38.68-3.66,1.85-9,2V6.05s0,0,0,0a1,1,0,0,0-2,0h0V8c-5.42-.14-8.7-1.34-9-1.94V6C6.31,5.32,10,4,16,4Zm1.77,24-.67,0L16,28l-1.11,0C9.51,27.84,6.26,26.63,6,26c0,0,0,0,0,0H6.1v-.11C6.74,25.2,9.94,24.14,15,24v2h0a1,1,0,0,0,2,0h0V24c5.33.14,8.61,1.31,9,2-.36.63-3.2,1.69-7.86,1.94Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelingExtrudeSvg);
export default __webpack_public_path__ + "static/media/ModelingExtrude_svg.0adf6c9d949b7f8573181b3975e1db89.svg";
export { ForwardRef as ReactComponent };